module.exports = __webpack_public_path__ + "static/img/answer-questionnaire2.62028b2.png";